import { render } from "./Virtualization.vue?vue&type=template&id=64324275"
import script from "./Virtualization.vue?vue&type=script&lang=js"
export * from "./Virtualization.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__